/**
 * Vue3 storefile:Velocity.PrimaryOffersites.Web\wwwroot\vue3\src\store\ExpressCheckout\ExpressCheckoutStore\ExpressCheckoutStore.js
 * make changes there also
 */
import * as actionTypes from '../types';
import { ExpressPayments } from '../../js/services/Payments/ExpressPayments';
import {
  SUMMARY_INCENTIVES,
  SUMMARY_SERVICEPROTECTIONPLAN,
  SUMMARY_DATA_DETAILS,
  PAYMENT_CONFIGURATION_DETAILS,
  PAYMENT_CONFIGURATION_DOWN_PAYMENT,
  EXPRESS_PAYMENT_STEPS_DETAILS,
  EXPRESS_SECTION_PAYMENT_BOX,
  EXPRESS_SECTION_INCENTIVES_BOX,
  EXPRESS_SECTION_TRADE_VALUES_BOX,
  EXPRESS_SECTION_CREDIT_SCORE_BOX,
  EXPRESS_SECTION_TAXES_BOX,
  EXPRESS_SECTION_SERVICE_PROTECTION_BOX,
  EXPRESS_SECTION_SCHEDULE_DELIVERY_BOX,
  EXPRESS_PAYMENTS_EVENT_FIRE,
  EXPRESS_PAYMENTS_SECTION_CALCULATED,
  TRANSACT_CURRENT_VIEWPORT,
  EXPRESS_PAYMENTS_SET_MAIN_TRADE_VALUE,
  EXPRESS_PAYMENTS_SET_YOUR_PRICE_DATA,
  TRANSACT_DEAL_DETAILS,
  TRANSACT_SET_ACTIVE_SECTION,
  TRANSACT_GET_ACTIVE_STEPS,
  TRANSACT_SET_ACTIVE_SECTION_LOADED,
  TRANSACT_GET_ACTIVE_SECTION_LOADED,
  TRANSACT_ACCESSORIES_LIST,
  TRANSACT_SELECTED_ACCESSORIES,
  SET_VEHICLES_LIST_ARRAY,
  SET_ACTIVE_PAYMENT_TABS,
  SET_ZIPCODE_MANUAL_STATUS_CHANGE,
} from '../../js/constants/expresspaymentconstants';
import store from '../store';
import {
  getMonthlyPayment,
  getTransactTradeDetailsData,
} from '../../js/services/TransactServices/TransactSummaryService';
import {
  callTransactPayments,
  doWeNeedTaxForThePayment,
  frameSummaryPaymentsData,
} from '../../js/services/Payments/PaymentsService';
import {
  TRANSACT_PAYMENT_SECTION,
  TRANSACT_TAX_SECTION,
} from '../StoreConstants/TransactConstants';
import {
  getLoggedInSelectedCity,
  getPaymentTypeStatementOnAppliesOptions,
} from '../../js/services/TransactServices/TransactBootstrap';
import { fireDrsTagManagerEvent } from '../../js/services/DRSEvents/DRSEventsService';
import axios from 'axios';
export const ExpressPaymentSettings = {
  state: {
    isZipCodeChangedManual: false,
    activePaymentTabs: [],
    activeTransactSections: {
      lease: [],
      finance: [],
      cash: [],
    },
    activeTransactSectionsLoaded: {
      lease: [],
      finance: [],
      cash: [],
    },
    selectedPaymentOption: '',
    transactSectionCurrentViewPort: TRANSACT_PAYMENT_SECTION,
    yourPriceData: '',
    paymentsEventFireObject: false,
    tradeBackClicked: false,
    dealDetails: '',
    tradeSliderValue: '',
    mainTradeValue: 0,
    showExpressCheckoutModal: false,
    appliedOptionsModal: window.isauthenticated === 'True',
    performSoftPull: false,
    paymentsLoaded: false,
    showLoading: false,
    paymentSettings: {
      lease: '',
      finance: '',
      cash: '',
    },
    serviceAndProtectionPlans: '',
    zipCodeSelected: {
      lease: '',
      finance: '',
      cash: '',
    },
    incentives: {
      lease: '',
      finance: '',
      cash: '',
    },
    creditScores: {
      lease: '',
      finance: '',
      cash: '',
    },
    summaryData: {
      lease: SUMMARY_DATA_DETAILS,
      finance: SUMMARY_DATA_DETAILS,
      cash: SUMMARY_DATA_DETAILS,
    },
    expressPaymentConfiguration: PAYMENT_CONFIGURATION_DETAILS,
    vehicleDetails: '',
    vehicleDetailsArray: [],
    regions: '',
    selectedCityIndex: '',
    taxZipCode: '',
    taxZipStateSelected: '',
    taxZipSelected: '',
    selectedCreditScore: 0,
    selectedTradeValue: 0,
    paymentsNotFoundError: {
      lease: '',
      cash: '',
      finance: '',
    },
    calculatePaymentsOnTabChanged: false,
    discountsIncentivesLoaded: {
      lease: false,
      finance: false,
      cash: false,
    },
    incentivesAmount: {
      lease: 0,
      finance: 0,
      cash: 0,
    },
    dummySelectedSliderValue: 0,
    tradeSelectedOptions: {
      type: '',
      value: '',
    },
    firstTimeTradeCall: true,
    stepsList: EXPRESS_PAYMENT_STEPS_DETAILS,
    currentVehicleDetails: '',
    creditScoreFormDetails: '',
    paymentLoadedOptions: [],
    checkboxClicked: false,
    scheduleDeliverySteps: 1,
    scheduleDeliveryData: {
      postData: {
        firstName: window?.userDetails?.firstname ? window.userDetails.firstname : '',
        lastName: window?.userDetails?.lastname ? window.userDetails.lastname : '',
        primaryEmailID: window?.userDetails?.email ? window.userDetails.email : '',
        primaryPhoneNumber: window?.userDetails?.phonenumber ? window.userDetails.phonenumber : '',
        zipCode: '',
      },
      consumerId: '',
      userPin: '',
      locationType: '',
      deliveryAddress: '',
      deliveryDateTime: '',
    },
    creditScoreBuyerFormData: {
      firstname: window?.userDetails?.firstname ? window.userDetails.firstname : '',
      lastname: window?.userDetails?.lastname ? window.userDetails.lastname : '',
      phonenumber: window?.userDetails?.phonenumber ? window.userDetails.phonenumber : '',
      email: window?.userDetails?.email ? window.userDetails.email : '',
      address_1: '',
      city: '',
      state: '',
      zip: '',
      birthday: '',
    },
    transact_enabled_sections: [],
    transact_sections: {
      [EXPRESS_SECTION_PAYMENT_BOX]: true,
      [EXPRESS_SECTION_INCENTIVES_BOX]: false,
      [EXPRESS_SECTION_TRADE_VALUES_BOX]: false,
      [EXPRESS_SECTION_CREDIT_SCORE_BOX]: false,
      [EXPRESS_SECTION_TAXES_BOX]: false,
      [EXPRESS_SECTION_SERVICE_PROTECTION_BOX]: false,
      [EXPRESS_SECTION_SCHEDULE_DELIVERY_BOX]: false,
    },
    tradeLeaseOptions: {
      turnLease: '',
      estimatedLease: '',
      remainingPayments: '',
      monthlyPayments: '',
    },
    expressSaveOffer: {
      stepCount: 1,
    },
    showExpressMailModal: false,
    isPaymentSectionCalculated: false,
    isTransactTradeStart: false,
    isTransactPaymentSectionStart: false,
    transactOpened: false,
    drsProgramCodes: '',
    mostRecentDrsActivity: '',
    accessoriesList: [],
    selectedAccessories: [],
    transactSaveOfferLogLeadItemId: '',
    showNavLinksOnTransact: true,
    transactPrintWindowVariables: '',
    deliveryFare: '',
  },

  getters: {
    getVehicleDetailsByVin: (state) => (vin) => {
      let vehicleFound = state.vehicleDetailsArray.find(
        (vehicle) => vehicle.vin && vehicle.vin.toLowerCase() === vin.toLowerCase()
      );

      if (!vehicleFound && window.vehicleDetailsArray?.length) {
        vehicleFound = window.vehicleDetailsArray.find(
          (vehicle) => vehicle.vin && vehicle.vin.toLowerCase() === vin.toLowerCase()
        );
      }

      return vehicleFound;
    },
    [actionTypes.EXPRESS_GET_SELECTED_SETTINGS]: (state) => {
      return state.paymentSettings[state.selectedPaymentOption.toLowerCase()];
    },
    [TRANSACT_GET_ACTIVE_STEPS]: (state) => {
      return state.activeTransactSections[state.selectedPaymentOption.toLowerCase()];
    },
    [TRANSACT_GET_ACTIVE_SECTION_LOADED]: (state) => {
      return state.activeTransactSectionsLoaded[state.selectedPaymentOption.toLowerCase()];
    },
    [actionTypes.EXPRESS_GET_SELECTED_INCENTIVES]: (state) => {
      return state.summaryData[state.selectedPaymentOption.toLowerCase()][SUMMARY_INCENTIVES];
    },
    [actionTypes.EXPRESS_GET_INCENTIVES]: (state) => {
      return state.incentives[state.selectedPaymentOption.toLowerCase()];
    },

    [actionTypes.EXPRESS_GET_SELECTED_SERVICE_PROTECTION_PLANS]: (state) => {
      return state.summaryData[state.selectedPaymentOption.toLowerCase()][
        SUMMARY_SERVICEPROTECTIONPLAN
      ];
    },
    [actionTypes.EXPRESS_GET_CALCULATED_MONTHLY_PAYMENT]: (state) => {
      return getMonthlyPayment(state.summaryData, state.selectedPaymentOption);
    },
    [actionTypes.EXPRESS_GET_SELECTED_SUMMARY_DATA]: (state) => {
      return state.summaryData[state.selectedPaymentOption];
    },
    [actionTypes.EXPRESS_GET_PAYMENT_OPTIONS_LOADED]: (state) => {
      state.paymentLoadedOptions = [];

      let data = getPaymentTypeStatementOnAppliesOptions(state);
      if (data) {
        state.paymentLoadedOptions.push(data);
      }

      if (state.selectedTradeValue) {
        state.paymentLoadedOptions.push(
          `The value of your ${state.currentVehicleDetails.year} ${state.currentVehicleDetails.make} ${state.currentVehicleDetails.model}`
        );
      }

      if (state.selectedCityIndex !== '') {
        state.paymentLoadedOptions.push(`Taxes and fees for zipcode ${state.taxZipCode}`);
      }

      return state.paymentLoadedOptions;
    },
    [actionTypes.EXPRESS_GET_CREDIT_SCORE_FORM_DETAILS](state) {
      return state.creditScoreFormDetails;
    },
  },
  mutations: {
    [SET_ZIPCODE_MANUAL_STATUS_CHANGE]: (state, payload) => {
      state.isZipCodeChangedManual = payload;
    },
    [SET_ACTIVE_PAYMENT_TABS]: (state, payload) => {
      state.activePaymentTabs = payload;
    },
    [SET_VEHICLES_LIST_ARRAY]: (state, payload) => {
      if (window.vehicleDetailsArray?.length) {
        window.vehicleDetailsArray.push(payload);
      } else {
        window.vehicleDetailsArray = [payload];
      }
      state.vehicleDetailsArray.push(payload);
    },

    [TRANSACT_ACCESSORIES_LIST]: (state, payload) => {
      state.accessoriesList = payload;
    },

    [TRANSACT_SELECTED_ACCESSORIES]: (state, payload) => {
      let accessories = [...state.selectedAccessories];
      let selectedAccessories = [];

      let found = 0;

      for (let accessory of accessories) {
        if (accessory.Code !== payload.Code) {
          selectedAccessories.push(accessory);
        } else {
          found = 1;
        }
      }

      if (!found) {
        selectedAccessories.push(payload);
      }
      state.selectedAccessories = selectedAccessories;
    },
    [EXPRESS_PAYMENTS_EVENT_FIRE]: (state, payload) => {
      state.paymentsEventFireObject = payload;
    },
    [EXPRESS_PAYMENTS_SET_YOUR_PRICE_DATA]: (state, payload) => {
      state.yourPriceData = payload;
    },
    [TRANSACT_SET_ACTIVE_SECTION]: (state, payload) => {
      state.activeTransactSections[payload.type] = payload.value;
    },
    [TRANSACT_SET_ACTIVE_SECTION_LOADED]: (state, payload) => {
      let steps = state.activeTransactSectionsLoaded[payload.type];
      if (steps.indexOf(payload.value) === -1) {
        state.activeTransactSectionsLoaded[payload.type].push(payload.value);
      }
    },
    [TRANSACT_DEAL_DETAILS]: (state, payload) => {
      state.dealDetails = payload;
    },
    [EXPRESS_PAYMENTS_SET_MAIN_TRADE_VALUE]: (state, payload) => {
      state.mainTradeValue = payload;
    },
    [TRANSACT_CURRENT_VIEWPORT]: (state, payload) => {
      state.transactSectionCurrentViewPort = payload;
    },
    [EXPRESS_PAYMENTS_SECTION_CALCULATED]: (state, payload) => {
      state.isPaymentSectionCalculated = payload;
    },
    [actionTypes.EXPRESS_SET_EXPRESS_SHOW_MAIL_MODAL]: (state, payload) => {
      state.showExpressMailModal = payload;
    },
    [actionTypes.EXPRESS_SET_SLIDER_VALUE]: (state, payload) => {
      state.tradeSliderValue = payload;
    },

    [actionTypes.EXPRESS_SET_TRANSACT_TRADE_LEASE_OPTIONS]: (state, payload) => {
      state.tradeLeaseOptions = payload;
    },
    [actionTypes.EXPRESS_SET_TRANSACT_OPENED]: (state, payload) => {
      state.transactOpened = payload;
    },
    [actionTypes.EXPRESS_TRANSACT_SAVE_OFFER_LOG_LEAD_ITEM_ID]: (state, payload) => {
      state.transactSaveOfferLogLeadItemId = payload;
    },
    [actionTypes.EXPRESS_SET_ALL_TRANSACT_SECTION_STEPS](state, payload) {
      let enabledTransactSteps = ExpressPayments.getEnabledTransactSteps(
        state.paymentSettings[state.selectedPaymentOption.toLowerCase()],
        state.incentives[state.selectedPaymentOption.toLowerCase()]
      );

      let actualSection = payload.type;
      let nextSection = '';

      if (actualSection === enabledTransactSteps[enabledTransactSteps.length - 1]) {
        state.checkboxClicked = true;
        state['transact_sections'][actualSection] = false;
        return;
      }

      let index = enabledTransactSteps.indexOf(actualSection);
      if (index !== -1) {
        nextSection = enabledTransactSteps[index + 1];
      }

      for (let enabledTransactStep of enabledTransactSteps) {
        if (nextSection === enabledTransactStep) {
          state['transact_sections'][enabledTransactStep] = true;
        } else {
          state['transact_sections'][enabledTransactStep] = false;
        }
      }
    },
    [actionTypes.EXPRESS_SET_TRANSACT_SECTION_STEP](state, payload) {
      let enabledTransactSteps = ExpressPayments.getEnabledTransactSteps(
        state.paymentSettings[state.selectedPaymentOption.toLowerCase()],
        state.incentives[state.selectedPaymentOption.toLowerCase()]
      );

      for (let enabledTransactStep of enabledTransactSteps) {
        state['transact_sections'][enabledTransactStep] = false;
      }

      state['transact_sections'][payload.type] = payload.value;
    },
    [actionTypes.EXPRESS_SET_BUYER_CALL_PERFORMED](state, payload) {
      state.performSoftPull = payload;
    },
    [actionTypes.EXPRESS_SET_SHOW_EXPRESS_CHECKOUT_MODAL](state, payload) {
      state.showExpressCheckoutModal = payload;
    },
    [actionTypes.EXPRESS_SET_BUYER_CREDIT_SCORE_FORM_DETAILS](state, payload) {
      state.creditScoreBuyerFormData = payload;
    },
    [actionTypes.EXPRESS_SET_SCHEDULE_DELIVERY_DATA](state, payload) {
      state.scheduleDeliveryData[payload['key']] = payload['value'];
    },
    [actionTypes.EXPRESS_SET_RESET_SCHEDULE_DELIVERY_STEPS](state) {
      state.scheduleDeliverySteps = 1;
    },
    [actionTypes.EXPRESS_SET_INCREMENT_SCHEDULE_DELIVERY_STEPS](state) {
      state.scheduleDeliverySteps++;
    },
    [actionTypes.EXPRESS_SET_DECREMENT_SCHEDULE_DELIVERY_STEPS](state) {
      state.scheduleDeliverySteps--;
    },
    [actionTypes.EXPRESS_SET_CHECKBOX_CLICKED](state, payload) {
      state.checkboxClicked = payload;
    },
    [actionTypes.EXPRESS_RESET_DATA](state) {
      state.firstTimeTradeCall = true;
      state.stepsList = EXPRESS_PAYMENT_STEPS_DETAILS;
      state.selectedCreditScore = 0;
      state.selectedTradeValue = 0;
      state.activeTransactSectionsLoaded = { cash: [], finance: [], lease: [] };
      state.activeTransactSections = { cash: [], finance: [], lease: [] };
      state.paymentSettings = { cash: '', finance: '', lease: '' };
      state.expressPaymentConfiguration = PAYMENT_CONFIGURATION_DETAILS;
    },
    [actionTypes.EXPRESS_SET_CREDIT_SCORE_FORM_DETAILS](state, payload) {
      state.creditScoreFormDetails = payload;
    },
    [actionTypes.EXPRESS_SET_CURRENT_VEHICLE_DETAILS](state, payload) {
      state.currentVehicleDetails = payload;
    },
    [actionTypes.EXPRESS_SET_APPLIED_OPTION_MODAL_CLOSED](state, payload) {
      state.appliedOptionsModal = payload;
    },
    [actionTypes.EXPRESS_SET_FIRST_TIME_TRADE_CALL](state, payload) {
      state.firstTimeTradeCall = payload;
    },
    [actionTypes.EXPRESS_SET_STEPS_LIST](state, payload) {
      state.stepsList[payload.type] = payload.value;
    },
    [actionTypes.EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT](state, payload) {
      let stateData = JSON.parse(JSON.stringify(state.incentivesAmount));
      stateData[payload.type] = payload.value;
      state.incentivesAmount = stateData;
    },
    [actionTypes.EXPRESS_SET_PAYMENT_CONFIGURATION](state, payload) {
      state.expressPaymentConfiguration = payload;
    },
    [actionTypes.EXPRESS_SET_SLIDER_SELECTED_TRADE_VALUE](state, payload) {
      state.dummySelectedSliderValue = payload;
    },
    [actionTypes.EXPRESS_SET_DISCOUNT_INCENTIVES_LOADED](state, payload) {
      state.discountsIncentivesLoaded[state.selectedPaymentOption.toLowerCase()] = payload;
    },

    [actionTypes.EXPRESS_SET_REGIONS_CHANGE](state, payload) {
      state.selectedCityIndex = payload;
    },
    summaryDataForCash(state, payload) {
      let stateData = JSON.parse(JSON.stringify(state.summaryData));
      stateData['cash'][payload.type] = payload.value;
      state.summaryData = stateData;
    },
    [actionTypes.EXPRESS_SET_SUMMARY_DATA](state, payload) {
      let stateData = JSON.parse(JSON.stringify(state.summaryData));
      if (payload.selectedPaymentOption) {
        stateData[payload.selectedPaymentOption][payload.type] = payload.value;
      } else {
        stateData[state.selectedPaymentOption][payload.type] = payload.value;
      }

      state.summaryData = stateData;
    },
    [actionTypes.EXPRESS_REPLACE_SUMMARY_DATA](state, payload) {
      let stateData = JSON.parse(JSON.stringify(state.summaryData));
      stateData = payload;
      state.summaryData = stateData;
    },
    [actionTypes.SET_TRANSACT_PRINT_WINDOW_VARIABLES](state, payload) {
      state.transactPrintWindowVariables = payload;
    },
    [actionTypes.EXPRESS_SET_SELECTED_PAYMENT_OPTION](state, payload) {
      state.selectedPaymentOption = payload;
    },
    [actionTypes.EXPRESS_SET_LOADING](state, payload) {
      state.showLoading = payload;
    },
    [actionTypes.EXPRESS_SET_LEASE_SETTINGS](state, payload) {
      state.paymentSettings.lease = payload;
    },
    [actionTypes.EXPRESS_SET_FINANCE_SETTINGS](state, payload) {
      state.paymentSettings.finance = payload;
    },
    [actionTypes.EXPRESS_SET_CASH_SETTINGS](state, payload) {
      state.paymentSettings.cash = payload;
    },
    [actionTypes.EXPRESS_SET_SERVICE_PROTECTION_PLANS](state, payload) {
      state.serviceAndProtectionPlans = payload;
    },
    [actionTypes.EXPRESS_SET_FINANCE_INCENTIVES](state, payload) {
      state.incentives.finance = payload;
    },
    [actionTypes.EXPRESS_SET_LEASE_INCENTIVES](state, payload) {
      state.incentives.lease = payload;
    },
    [actionTypes.EXPRESS_SET_CASH_INCENTIVES](state, payload) {
      state.incentives.cash = payload;
    },

    [actionTypes.EXPRESS_SET_INCENTIVES_SELECTED_ZIPCODE](state, payload) {
      state.zipCodeSelected[payload.selectedPayment.toLowerCase()] = payload.value;
    },
    [actionTypes.EXPRESS_SET_CREDIT_SCORES](state, payload) {
      state.creditScores[payload.selectedPayment.toLowerCase()] = payload.value;
    },
    [actionTypes.EXPRESS_SET_SELECTED_SERVICE_PROTECTION_PLAN](state, payload) {
      state.selectedServiceProtectionPlan[payload.selectedPayment.toLowerCase()] = payload.value;
    },
    [actionTypes.EXPRESS_SET_PAYMENT](state, payload) {
      state.Payment = payload;
    },
    [actionTypes.EXPRESS_SET_PAYMENTS_LOADED](state, payload) {
      state.paymentsLoaded = payload;
    },
    [actionTypes.EXPRESS_SET_VEHICLE_DETAILS](state, payload) {
      state.vehicleDetails = payload;
    },
    [actionTypes.EXPRESS_SET_EXPRESS_SAVE_OFFER_DETAILS](state, payload) {
      state.expressSaveOffer[payload.type] = payload.value;
    },
    [actionTypes.EXPRESS_SET_REGIONS](state, payload) {
      state.regions = payload;
    },
    [actionTypes.EXPRESS_SET_TAXES_ZIP_CODE](state, payload) {
      sessionStorage.setItem(window.tid + '-tax-zip-code', String(payload));
      state.taxZipCode = payload;
    },
    [actionTypes.EXPRESS_SET_TAXES_ZIP_STATE_SELECTED](state, payload) {
      state.taxZipStateSelected = payload;
    },
    [actionTypes.EXPRESS_SET_TAXES_ZIP_SELECTED](state, payload) {
      state.taxZipSelected = payload;
    },
    [actionTypes.EXPRESS_SET_SELECTED_CREDITSCORE](state, payload) {
      state.calculatePaymentsOnTabChanged = true;
      state.selectedCreditScore = payload;
    },
    [actionTypes.EXPRESS_SET_SELECTED_TRADE_VALUE](state, payload) {
      state.selectedTradeValue = payload;
    },
    [actionTypes.EXPRESS_TRADE_BACK_CLICKED](state, payload) {
      state.tradeBackClicked = payload;
    },

    [actionTypes.EXPRESS_SET_PAYMENTS_NOT_FOUND_ERROR](state, payload) {
      state.paymentsNotFoundError[payload.type] = payload.message;
    },
    [actionTypes.EXPRESS_SET_CALCULATE_PAYMENTS_TAB_CHANGED](state, payload) {
      state.calculatePaymentsOnTabChanged = payload;
    },
    [actionTypes.EXPRESS_SET_TRADE_SELECTED_OPTION_VALUES](state, payload) {
      state.tradeSelectedOptions[payload.type] = payload.value;
    },
    [actionTypes.SAVE_DRS_PROGRAM_CODES](state, payload) {
      state.mostRecentDrsActivity = payload;
      try {
        let drsProgramCodesList = [];
        if (state.drsProgramCodes) {
          drsProgramCodesList = state.drsProgramCodes.split('|');
          if (!drsProgramCodesList.some((item) => item === payload)) {
            drsProgramCodesList.push(payload);
          }
        } else {
          drsProgramCodesList.push(payload);
        }

        state.drsProgramCodes = drsProgramCodesList.join('|');
      } catch (e) {
        console.log(e);
      }
    },
    [actionTypes.CLEAR_DRS_PROGRAM_CODES](state, payload) {
      if (payload) {
        state.drsProgramCodes = '';
      }
    },
    [actionTypes.EXPRESS_SET_TRADE_START_EVENT](state, payload) {
      state.isTransactTradeStart = payload;
    },
    [actionTypes.EXPRESS_SET_PAYMENT_START_EVENT](state, payload) {
      state.isTransactPaymentSectionStart = payload;
    },
    [actionTypes.EXPRESS_SET_SHOW_NAV_LINKS_ON_TRANSACT]: (state, payload) => {
      state.showNavLinksOnTransact = payload;
    },
    [actionTypes.EXPRESS_SET_RUN_BUGGY_DELIVERY_TYPE]: (state, payload) => {
      state.deliveryFare = payload;
    },
  },
  actions: {
    async [actionTypes.EXPRESS_CALL_TAXES_FEES_REGIONS](context, payload) {
      context.commit(actionTypes.EXPRESS_SET_LOADING, true);

      let response = payload.response;
      context.commit(actionTypes.EXPRESS_SET_REGIONS, []);
      try {
        context.commit(actionTypes.EXPRESS_SET_REGIONS, response);

        let selectedSettings = context.getters[actionTypes.EXPRESS_GET_SELECTED_SETTINGS];

        if (window.isauthenticated === 'True') {
          let selectedCityIndex = '';
          if (context.state.dealDetails) {
            selectedCityIndex = ExpressPayments.getSelectedCity(response, {
              city: context.state.dealDetails.taxesRegion,
            });
          } else if (selectedSettings.useDealerZipCodeForTaxes) {
            selectedCityIndex = 0;
          } else {
            selectedCityIndex = ExpressPayments.getSelectedCity(
              response,
              context.state.currentVehicleDetails
            );
          }

          context.commit(actionTypes.EXPRESS_SET_REGIONS_CHANGE, selectedCityIndex);
          if ('initialLoad' in payload && payload.initialLoad) {
            context.commit(TRANSACT_SET_ACTIVE_SECTION_LOADED, {
              type: context.state.selectedPaymentOption,
              value: TRANSACT_TAX_SECTION,
            });
          }
          getLoggedInSelectedCity(context.state, response, selectedSettings);
        }
        context.commit(actionTypes.EXPRESS_SET_LOADING, false);
      } catch (err) {
        console.log(err);
      }
    },

    async [actionTypes.EXPRESS_CALL_PAYMENTS_DATA](context) {
      store.commit(EXPRESS_PAYMENTS_SECTION_CALCULATED, true);
      context.commit(actionTypes.EXPRESS_SET_LOADING, true);
      context.commit(actionTypes.EXPRESS_SET_PAYMENTS_LOADED, false);
      let response = '';

      const selectedPaymentOption = context.state.selectedPaymentOption.toLowerCase();
      try {
        const withTax = doWeNeedTaxForThePayment(selectedPaymentOption);

        response = await callTransactPayments(selectedPaymentOption, withTax);
      } catch (error) {
        context.commit(actionTypes.EXPRESS_SET_PAYMENTS_NOT_FOUND_ERROR, {
          type: selectedPaymentOption.toLowerCase(),
          message: 'We are having difficulty finding the Payments. Please try with other options',
        });
        console.log(error);
      }

      const isPaymentCollectionAvailable = response?.PaymentCollection?.length > 0;

      context.commit('setExpressPaymentsFeesData', '');
      if (response?.FeesAndTaxesCollection) {
        context.commit('setExpressPaymentsFeesData', response.FeesAndTaxesCollection);
      }

      context.commit(actionTypes.EXPRESS_SET_PAYMENTS_NOT_FOUND_ERROR, {
        type: selectedPaymentOption.toLowerCase(),
        message: '',
      });
      frameSummaryPaymentsData(response);

      if (isPaymentCollectionAvailable) {
        if (context.state.paymentsEventFireObject) {
          try {
            context.commit(EXPRESS_PAYMENTS_EVENT_FIRE, false);
          } catch (e) {
            console.log(e);
          }
        }
      }

      context.commit(actionTypes.EXPRESS_SET_PAYMENTS_LOADED, true);
      context.commit(actionTypes.EXPRESS_SET_LOADING, false);

      //fire DRS events every time payment value changes
      if (context.state.showExpressCheckoutModal) {
        fireDrsTagManagerEvent('DRS-Payment-Calculator');
      }
      try {
        //transact save deal on every payment setting change
        const {
          scheduleDeliveryData,
          selectedPaymentOption,
          expressPaymentConfiguration,
          dummySelectedSliderValue,
          selectedCreditScore,
          creditScoreBuyerFormData,
          performSoftPull,
          creditScoreFormDetails,
          regions,
          selectedCityIndex,
          taxZipCode,
          tradeSelectedOptions,
          tradeLeaseOptions,
        } = context.state;
        const summaryData = context.getters[actionTypes.EXPRESS_GET_SELECTED_SUMMARY_DATA];
        const monthlyPayment = context.getters[actionTypes.EXPRESS_GET_CALCULATED_MONTHLY_PAYMENT];
        const selectedIncentives = context.getters[actionTypes.EXPRESS_GET_SELECTED_INCENTIVES];

        const { vehicledetails, blackbookfilterdata } = store.state.mytradevaluedetails;
        const postData = {
          dealsDto: {
            sessionId: window.tid,
            isActive: false,
            dealerId: window.accountId,
            campaignId: window.campaignId,
            pin: scheduleDeliveryData.userPin,
            vin: window.paymentsvin,
            paymentType: selectedPaymentOption,
            downPayment: expressPaymentConfiguration[PAYMENT_CONFIGURATION_DOWN_PAYMENT],
            incentivesApplied: summaryData.paymentData.IncentiveCash,
            tradeYear: vehicledetails.year,
            tradeMake: vehicledetails.make,
            tradeModel: vehicledetails.model,
            tradeTrim: vehicledetails.trim,
            tradeStyle: blackbookfilterdata.style,
            tradeMileage: blackbookfilterdata.miles,
            tradeValue: '', //Need to know
            equity: dummySelectedSliderValue,
            appliedTrade: summaryData.paymentData.TradeEquity,
            cashBack: summaryData.paymentData.Cashback,
            creditScore: selectedCreditScore,
            performedSoftPull: performSoftPull,
            firstName: creditScoreBuyerFormData.firstname,
            lastName: creditScoreBuyerFormData.lastname,
            phone: creditScoreBuyerFormData.phonenumber,
            email: creditScoreBuyerFormData.email,
            address: creditScoreBuyerFormData.address_1,
            city: creditScoreBuyerFormData.city,
            state: creditScoreBuyerFormData.state,
            zip: creditScoreBuyerFormData.zip,
            dobDay: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[0]
              : '',
            dobMonth: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[1]
              : '',
            dobYear: creditScoreBuyerFormData.birthday
              ? creditScoreBuyerFormData.birthday.split('/')[2]
              : '',
            taxesZipCode: taxZipCode,
            taxesRegion:
              regions && selectedCityIndex && regions[selectedCityIndex]
                ? regions[selectedCityIndex].City +
                  ' ' +
                  regions[selectedCityIndex].State +
                  ' ' +
                  regions[selectedCityIndex].County
                : '',
            servicePlansApplied: getTotalServiceProtectionPlans(summaryData),
            scheduleDateTime: scheduleDeliveryData.deliveryDateTime
              ? new Date(scheduleDeliveryData.deliveryDateTime).toISOString()
              : '',
            delivaryAddress: scheduleDeliveryData.delivaryAddress,
            delivaryLocation: scheduleDeliveryData.locationType,
            coordinatorName: creditScoreFormDetails.deliveryCordinatorName,
            coordinatorEmail: creditScoreFormDetails.deliveryCordinatorEmail,
            coordinatorPhone: creditScoreFormDetails.deliveryCordinatorPhoneNumber,
            paymentDetails: JSON.stringify(summaryData.paymentData),
            cFirstName: scheduleDeliveryData.postData.firstName,
            cLastName: scheduleDeliveryData.postData.lastName,
            cEmail: scheduleDeliveryData.postData.primaryEmailID,
            cPhoneNumber: scheduleDeliveryData.postData.primaryPhoneNumber,
            cZipCode: scheduleDeliveryData.postData.zipCode,
            monthlyPayment: monthlyPayment.toFixed(2),
            serviceProtectionPlansValue:
              ExpressPayments.getTotalServiceProtectionPlans(summaryData),
            vdpAccountId: window.vdpAccountId ? window.vdpAccountId : 0,
          },

          dealIncentivesDtos:
            selectedIncentives && selectedIncentives.length > 0 ? selectedIncentives : [],
          dealServicePlansDtos:
            summaryData.serviceProtectionPlan && summaryData.serviceProtectionPlan.length > 0
              ? summaryData.serviceProtectionPlan
              : [],
        };

        if (tradeSelectedOptions.type) {
          if (tradeSelectedOptions.type.toLowerCase() === 'leased') {
            if (tradeLeaseOptions.turnLease === 'Turn in my lease early') {
              postData.dealsDto.LeasePayoffCurrentMonthlyPayment =
                tradeLeaseOptions.monthlyPayments;
              postData.dealsDto.leasePayoffRemainingPayment = tradeLeaseOptions.remainingPayments;
              postData.dealsDto.leasePayoffOption = tradeLeaseOptions.turnLease;
            } else if (tradeLeaseOptions.turnLease === 'Buy out my lease') {
              postData.dealsDto.leasePayoffOption = tradeLeaseOptions.turnLease;
              postData.dealsDto.leasePayOffValue = tradeLeaseOptions.estimatedLease;
            } else {
              // No action needed for other cases.
            }
          }

          if (tradeSelectedOptions.type.toLowerCase() === 'financed') {
            postData.dealsDto.financePayOffValue = tradeSelectedOptions.value;
          }
        }

        const tradeDetails = getTransactTradeDetailsData();
        if (tradeDetails?.TradeYear) {
          postData.dealsDto.tradeYear = tradeDetails.TradeYear;
          postData.dealsDto.tradeMake = tradeDetails.TradeMake;
          postData.dealsDto.tradeModel = tradeDetails.TradeModel;
          postData.dealsDto.tradeTrim = tradeDetails.TradeTrim;
          postData.dealsDto.tradeMileage = tradeDetails.TradeMileage;
        }

        axios
          .post(`${window.ApiBaseUrl}/TransactDeals/SaveDeal`, postData)
          .then(() => {})
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.error(err);
      }
    },
  },
};

export function getTotalServiceProtectionPlans(summaryData) {
  let amount = 0;
  try {
    for (let item of summaryData.serviceProtectionPlan) {
      if (Number(item.cashPrice)) {
        amount += item.cashPrice;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return amount;
}
